import React, { Component } from "react";
import _ from 'i18n';
import EventLineChartLegendRow from "./EventLineChartLegendRow";
import { Col, Row } from "antd";
import { formatAmount } from "../../../../services/utils";
import { connect } from "react-redux";
import { setEventStatsSaison } from "../../../../actions/actions";
import { getSeasonsValues } from "../../../../actions/thunks/eventStats";
import { nbrInscrits } from "./data";

@connect(store => ({
  auth: store.auth,
}))

class EventLineChartLegendFormat extends Component {

  calculateRegistrantsNumberByAppType = (lineName, transformedData) => {
    const { startMonth, endMonth } = this.props;

    if (transformedData.length === 0 || !transformedData)
      return 0;


    return transformedData.reduce(function (tot, record, index) {
      if (!startMonth && !endMonth)
        return tot + record[lineName];

      return startMonth <= index + 1 && index + 1 <= endMonth ? tot + record[lineName] : tot;
    }, 0);

  }

  calculateRegistrantsNumberByAppTypeFormat = (lineName, transformedSourceData) => {
    const { startMonth, endMonth } = this.props;

    if (transformedSourceData.length === 0 || !transformedSourceData)
      return 0;

    return transformedSourceData.reduce(function (tot, record, index) {
      if (!startMonth && !endMonth)
        return tot + record[lineName];

      return startMonth <= index + 1 && index + 1 <= endMonth ? tot + record[lineName] : tot;
    }, 0);

  }

  constructor(props) {
    super(props);

    this.state = {
      seasons: [],
    };
  }

  componentDidMount() {
    this.getSeasons();
  }

  componentDidUpdate(nextProps, nextState, nextContext) {
    if (nextProps.eventStatsFilter.year !== this.props.eventStatsFilter.year) {
      this.getSeasons();
    }

    if (nextProps.seasons && (nextProps.seasons.items !== this.props.seasons.items)) {
      let seasons = this.props.seasons.items;
      let newSeasons = [];

      newSeasons = seasons.map(part => {
        let label = '';
        if (part.name_fr) {
          label = part.name_fr;
        } else if (part.name_en) {
          label = part.name_en;
        } else if (part.name_nl) {
          label = part.name_nl;
        }

        return { legend: label, color: this.getRandomColor(), lineName: label };
      });

      newSeasons.push({ legend: 'NONE', color: this.getRandomColor(), lineName: "NONE" });

      this.setState({ seasons: newSeasons });
    }
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getSeasons = () => {
    let params = {};

    if (this.props.auth.currentClient) {
      params.issuerId = this.props.auth.currentClient.id;
    }

    this.props.getSeasonsValues(params);
  }

  getDaysOfMonthFromString(monthYearArray) {
    const daysArray = [];

    monthYearArray.forEach(monthYear => {
      const [year, month] = monthYear.split('-').map(Number);

      const daysInMonth = new Date(year, month, 0).getDate();

      for (let i = 1; i <= daysInMonth; i++) {
        const day = String(i).padStart(2, '0');
        const monthFormatted = String(month).padStart(2, '0');
        daysArray.push(`${day}/${monthFormatted}`);
      }
    });

    return daysArray;
  }

  getYearsArray() {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];

    for (let year = 2018; year <= currentYear; year++) {
      yearsArray.push(year);
    }

    return yearsArray;
  }

  render() {
    const { auth } = this.props;
    const {
      updateChartLinesToShow,
      fetching,
      isError,
      formatData,
      formatCAData,
      chartLinesToShowFormat,
      sourceFormatData,
      sourceFormatDataCA,
      year,
      sourceYear,
      type,
      startMonth,
      endMonth,
      seasonsToShow,
      frequency,
      period,
      showSpinner,
    } = this.props;

    let eventTypes = [];

    let totalRegistrantNumber = 0;
    let totalCANumber = 0;
    let totalSourceRegistrantNumber = 0;
    let totalSourceCANumber = 0;

    const transformedData = [];
    const transformedDataCA = [];

    const transformedSourceData = [];
    const transformedSourceCA = [];

    const months = ["Jan", "Fév", "Mar", "Avr", "Mai", "Jui", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"];
    const daysOfMonth = this.getDaysOfMonthFromString(period);
    const years = this.getYearsArray();

    let monthOrDaysOrYears = [];

    switch (frequency) {
      case 'MONTHLY':
        monthOrDaysOrYears = months;
        break;
      case 'DAILY':
        monthOrDaysOrYears = daysOfMonth;
        break;
      case 'YEARLY':
        monthOrDaysOrYears = years;
        break;
      default:
        break;
    }

    monthOrDaysOrYears.forEach((monthOrDayOrYear, index) => {
      const monthData = { "name": monthOrDayOrYear };

      Object.keys(formatData).forEach(entity => {
        if (entity.length === 0) return;
        let entityTotal = 0;
        if (formatData[entity][index]) {
          entityTotal =
            formatData[entity][index].formations +
            formatData[entity][index].cycles +
            formatData[entity][index].cycles_essential +
            formatData[entity][index].saisons +
            formatData[entity][index].monthly_premium +
            formatData[entity][index].yearly_premium +
            formatData[entity][index].congrès;
        }

        monthData[entity] = entityTotal;
      });
      transformedData.push(monthData);
    });

    if (sourceFormatData && sourceFormatDataCA) {
      monthOrDaysOrYears.forEach((monthOrDayOrYear, index) => {
        const monthData = { "name": monthOrDayOrYear };

        Object.keys(sourceFormatData).forEach(entity => {
          if (entity.length === 0) return;
          let entityTotal = 0;
          if (sourceFormatData[entity][index]) {
            entityTotal =
              sourceFormatData[entity][index].formations +
              sourceFormatData[entity][index].cycles +
              sourceFormatData[entity][index].cycles_essential +
              sourceFormatData[entity][index].saisons +
              sourceFormatData[entity][index].monthly_premium +
              sourceFormatData[entity][index].yearly_premium +
              sourceFormatData[entity][index].congrès;
          }

          monthData[entity] = entityTotal;
        });
        transformedSourceData.push(monthData);
      });

      monthOrDaysOrYears.forEach((monthOrDayOrYear, index) => {
        const monthData = { "name": monthOrDayOrYear };

        Object.keys(sourceFormatDataCA).forEach(entity => {
          if (entity.length === 0) return;
          let entityTotal = 0;
          if (sourceFormatDataCA[entity][index]) {
            entityTotal =
              sourceFormatDataCA[entity][index].formations +
              sourceFormatDataCA[entity][index].cycles +
              sourceFormatDataCA[entity][index].cycles_essential +
              sourceFormatDataCA[entity][index].saisons +
              sourceFormatDataCA[entity][index].monthly_premium +
              sourceFormatDataCA[entity][index].yearly_premium +
              sourceFormatDataCA[entity][index].congrès;
          }

          monthData[entity] = entityTotal;
        });
        transformedSourceCA.push(monthData);
      });
    }

    // Loop through each month
    monthOrDaysOrYears.forEach((monthOrDay, index) => {
      const monthData = { "name": monthOrDay };

      // Loop through each entity (Utopix, KA, Lexalert, etc.)
      Object.keys(formatCAData).forEach(entity => {
        if (entity.length === 0) return;
        // Initialize entityTotal
        let entityTotal = 0;

        // Check if the entity has data for the current month
        if (formatCAData[entity][index]) {
          // If data exists, sum the values for that month
          entityTotal =
            formatCAData[entity][index].formations +
            formatCAData[entity][index].cycles +
            formatCAData[entity][index].cycles_essential +
            formatCAData[entity][index].saisons +
            formatCAData[entity][index].monthly_premium +
            formatCAData[entity][index].yearly_premium +
            formatCAData[entity][index].congrès;
        }

        // Add the total to the monthData object for the current entity
        monthData[entity] = entityTotal;
      });

      // Push the monthData for the current month
      transformedDataCA.push(monthData);
    });

    if (auth.currentClient.businessType === 'SUPER_CHAIN') {
      eventTypes = [
        { legend: _('TRAININGS'), color: "#18A0FB", lineName: "formations" },
        { legend: _('CYCLES'), color: "#5F5DE8", lineName: "cycles" },
        { legend: _('CYCLES_ESSENTIAL'), color: "#14B7AD", lineName: "cycles_essential" },
        { legend: _('SEASONS'), color: "#F47F4D", lineName: "saisons" },
        { legend: _('MONTHLY_PREMIUM'), color: "#FB1E5B", lineName: "monthly_premium" },
        { legend: _('YEARLY_PREMIUM'), color: "#FFD433", lineName: "yearly_premium" },
        { legend: _('CONGRESS'), color: "#6D7F92", lineName: "congrès" },
      ];
    } else if (auth.currentClient.businessType === 'MASTER_CHAIN') {
      eventTypes = [
        { legend: _('TRAININGS'), color: "#18A0FB", lineName: "formations" },
        { legend: _('CYCLES'), color: "#5F5DE8", lineName: "cycles" },
      ];
    } else {
      eventTypes = [
        { legend: _('TRAININGS'), color: "#18A0FB", lineName: "formations" },
      ];
    }

    console.log("==== transformedData", transformedData, transformedDataCA);
    console.log("==== transformedSourceData", transformedSourceData, transformedSourceCA);



    if (!showSpinner) {
      seasonsToShow.forEach(({ lineName }) => {
        if (lineName.length === 0) return;
        if (chartLinesToShowFormat.includes(lineName)) {

          totalRegistrantNumber += this.calculateRegistrantsNumberByAppType(lineName, transformedData);
          totalCANumber += this.calculateRegistrantsNumberByAppType(lineName, transformedDataCA);

          if (sourceFormatData) {
            totalSourceRegistrantNumber += this.calculateRegistrantsNumberByAppType(lineName, transformedSourceData);
            totalSourceCANumber += this.calculateRegistrantsNumberByAppType(lineName, transformedSourceCA);
          }
        }
      });
    }

    return (
      <div>
        <div style={{ height: '420px', overflowY: 'auto' }}>
          {
            sourceFormatData &&
            <Row className={'legend-row'}>
              <Col span={7} />
              <Col span={8} className={'registrants-number flex justify-center'} style={{ justifyContent: "end", color: "#29394d", opacity: 0.7 }}>{year}</Col>
              <Col span={8} className={'registrants-number flex justify-center'} style={{ justifyContent: "end", color: "#29394d" }}>{sourceYear}</Col>
            </Row>
          }
          {
            <Row className={'legend-row'}>
              <Col span={sourceFormatData ? 7 : 15} />
              <Col span={4} className={'registrants-number flex'} style={{ paddingLeft: '20px', color: "#29394d", opacity: sourceFormatData ? 0.7 : 1 }}>Inscriptions</Col>
              <Col span={4} className={'registrants-number flex justify-center'} style={{ justifyContent: "right", color: "#29394d", opacity: sourceFormatData ? 0.7 : 1 }}>C.A</Col>
              {sourceFormatData && <Col span={4} className={'registrants-number flex'} style={{ paddingLeft: '20px', color: "#29394d" }}>Inscriptions</Col>}
              {sourceFormatData && <Col span={4} className={'registrants-number flex justify-center'} style={{ justifyContent: "right", color: "#29394d" }}>C.A</Col>}
            </Row>
          }
          {seasonsToShow.map(({ legend, color, lineName }, index) => lineName.length > 0 && (
            <React.Fragment>
              <hr />
              <EventLineChartLegendRow
                legend={legend}
                color={color}
                registrantNumber={this.calculateRegistrantsNumberByAppType(lineName, transformedData)}
                caNumber={this.calculateRegistrantsNumberByAppType(lineName, transformedDataCA)}
                updateChartLinesToShow={updateChartLinesToShow}
                chartLinesToShow={chartLinesToShowFormat}
                fetching={showSpinner}
                isError={isError}
                lineName={lineName}
                sourceRegistrantNumber={fetching === false && sourceFormatData ? this.calculateRegistrantsNumberByAppTypeFormat(lineName, transformedSourceData) : null}
                sourceCARegistrantNumber={fetching === false && sourceFormatData ? this.calculateRegistrantsNumberByAppTypeFormat(lineName, transformedSourceCA) : null}
                type={type}
                startMonth={startMonth}
                endMonth={endMonth}
                sourceData={transformedSourceData}
              />
              {index === seasonsToShow.length - 1 && <hr />}
            </React.Fragment>
          ))}
        </div>
        {
          showSpinner === false &&
          <Row className={'legend-row'} >
            <Col span={sourceFormatData ? 5 : 15} className={'registrants-number flex '} style={{ color: "#29394d" }}>Total</Col>
            {sourceFormatData &&
              <Col span={2} className={'registrants-number flex'} style={{ marginLeft: "6px" }}>
                {
                  Math.round((((totalSourceCANumber / 100) - (totalCANumber / 100)) / (totalCANumber / 100 == 0 ? 1 : totalCANumber / 100)) * 100) > 0
                    ?
                    <React.Fragment>
                      <img src="/img/icons/manage-BM/BM_plus.svg" />
                      <span className={'ml-1'} style={{ color: '#02af8e', fontSize: '12px' }}>{Math.abs(parseFloat(((((totalSourceCANumber / 100) - (totalCANumber / 100)) / (totalCANumber / 100 == 0 ? totalSourceCANumber / 100 : totalCANumber / 100)) * 100).toFixed(2)))}% </span>
                    </React.Fragment>
                    :
                    <React.Fragment>
                      <img src="/img/icons/manage-BM/BM_moins.svg" className={'mr-1'} />
                      <span className={'mr-1'} style={{ color: '#fe3745', fontSize: '12px' }}>{Math.abs(parseFloat(((((totalSourceCANumber / 100) - (totalCANumber / 100)) / (totalCANumber / 100 == 0 ? totalSourceCANumber / 100 : totalCANumber / 100)) * 100).toFixed(2)))}% </span>
                    </React.Fragment>
                }
              </Col>
            }
            <Col span={4} className={'registrants-number flex'} style={{ paddingLeft: '20px', color: "#29394d", opacity: sourceFormatData ? 0.7 : 1 }}>{totalRegistrantNumber}</Col>
            <Col span={4} className={'registrants-number flex '} style={{ justifyContent: "right", color: "#29394d", opacity: sourceFormatData ? 0.7 : 1 }}>{formatAmount(totalCANumber)}</Col>
            {sourceFormatData && <Col span={4} className={'registrants-number flex'} style={{ paddingLeft: '20px', color: "#29394d" }}>{totalSourceRegistrantNumber}</Col>}
            {sourceFormatData && <Col span={4} className={'registrants-number flex'} style={{ justifyContent: "right", color: "#29394d" }}>{formatAmount(totalSourceCANumber)}</Col>}
            <Col span={1} />
          </Row>
        }
      </div>
    );
  }
}



const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  seasons: state.seasons,
  auth: state.auth
});

const mapDispatchToProps = {
  setEventStatsSaison,
  getSeasonsValues
};

export default connect(mapStateToProps, mapDispatchToProps)(EventLineChartLegendFormat);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventLineChartLegendFormat.js